import React, { useState, useEffect } from "react";
import { Grid, Row, Col } from "react-bootstrap";
import moment from "moment";


import Card from "Front/components/Card/Card.jsx";
import AddOnServices from "./AddOnServices";
import BillCategoryList from "./BillCategoryList";
import BillingList from "./BillingList";
import BillingReport from "./BillingReport";

const Billing = (props) => {
    const [startDate, setStartDate] = useState(
        localStorage.getItem("billingStartDate") || moment().format("YYYY-MM-DD")
    );
    const [endDate, setEndDate] = useState(
        localStorage.getItem("billingEndDate") || moment().format("YYYY-MM-DD")
    );
    const [activeTab, setActiveTab] = useState("billListTab");

    useEffect(() => {
        localStorage.setItem("billingStartDate", startDate);
        localStorage.setItem("billingEndDate", endDate);
    }, [startDate, endDate]);

    return (
        <>
            <div className="main-content settings-wrapper">
                <Grid fluid>
                    <Card
                        // title={"Settings"}
                        content={
                            <div className="tabs-wrapper">
                                <div className="tabs-btns-group">
                                    <button
                                        className={
                                            activeTab == "billListTab"
                                                ? "btn-tab tab-active"
                                                : "btn-tab"
                                        }
                                        type="button"
                                        onClick={() => {
                                            setActiveTab("billListTab");
                                            // setActiveSideButton("consultationButtonActive");
                                        }}
                                    >
                                        Bill List
                                    </button>
                                    <button
                                        className={
                                            activeTab == "reportTab"
                                                ? "btn-tab tab-active"
                                                : "btn-tab"
                                        }
                                        type="button"
                                        onClick={() => setActiveTab("reportTab")}
                                    >
                                        Summary
                                    </button>
                                    <button
                                        className={
                                            activeTab == "categoryTab"
                                                ? "btn-tab tab-active"
                                                : "btn-tab"
                                        }
                                        type="button"
                                        onClick={() => setActiveTab("categoryTab")}
                                    >
                                        Category
                                    </button>
                                    <button
                                        className={
                                            activeTab == "servicesTab"
                                                ? "btn-tab tab-active"
                                                : "btn-tab"
                                        }
                                        type="button"
                                        onClick={() => setActiveTab("servicesTab")}
                                    >
                                        Services
                                    </button>
                                </div>
                                <div className="tabs-content">
                                    <div className="tabs-content-inner">
                                        <div style={{ width: "100%" }}>
                                            {activeTab == "billListTab" &&
                                                <div className="consultation-validity-period">
                                                    <BillingList
                                                        startDate={startDate}
                                                        endDate={endDate}
                                                        setStartDate={setStartDate}
                                                        setEndDate={setEndDate}
                                                    />
                                                </div>
                                            }

                                            {activeTab == "categoryTab" && (
                                                <div className="clinic-preferences-tab">
                                                    <BillCategoryList />
                                                </div>
                                            )}

                                            {activeTab == "servicesTab" && (
                                                <div className="prescription-tab">
                                                    <AddOnServices />
                                                </div>
                                            )}
                                            {activeTab == "reportTab" && (
                                                <div className="prescription-tab">
                                                    <BillingReport
                                                        startDate={startDate}
                                                        endDate={endDate}
                                                        setStartDate={setStartDate}
                                                        setEndDate={setEndDate}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        }
                    />
                </Grid>
            </div>
        </>
    )
}

export default Billing